export const editMutations = <const>{
	VYROBEK_ND_DODAVATEL_SELECT_MAPPER: 'VYROBEK_ND_DODAVATEL_SELECT_MAPPER',
};
